module.exports = __webpack_public_path__ + "fonts/dm-sans-v6-latin-regular.54706a9.woff";